import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ArticleDetail from '../views/ArticleDetail.vue'
import Admin from '../views/Admin.vue'
import AdminArticles from '../views/AdminArticles.vue'
import AdminEdit from '../views/AdminEdit.vue'
import AdminCrawl from '../views/AdminCrawl.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/article/:id', name: 'ArticleDetail', component: ArticleDetail },
  { path: '/login', name: 'Login', component: Login },
  { path: '/admin', name: 'Admin', component: Admin, meta: { requiresAuth: true },
    children: [
      { path: '', name: 'AdminArticles', component: AdminArticles },
      { path: 'edit/:id?', name: 'AdminEdit', component: AdminEdit },
      { path: 'crawl', name: 'AdminCrawl', component: AdminCrawl }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
